import { Box, InputLabel, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import MobileHeader from "../../layout/AuthLayout/MobileHeader";
import ArrowTickLeft from "../../../media/images/icons/arrow-tick-left";
import AuthFooter from "../../layout/AuthLayout/Footer";
import KeyShieldSVG from "../../../media/images/icons/key-shield";
import CloseCircleSVG from "../../../media/images/icons/close-icon";
import SmsTrackingIcon from "../../../media/images/icons/sms-tracking";
import InfoTriangle from "../../../media/images/icons/info-triangle";
import { useFormik } from "formik";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../services/fetcher";
import { useAppDispatch } from "../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../redux/features/snackbarSlice";
import HandleSuccessForgetPassModal from "./SuccessModal";

import * as yup from "yup";

export default function ForgetPasswordPage() {
  const theme = useTheme();
  const navigate = useNavigate();

  const [successModal, setSuccessModal] = useState(false);

  const dispatch = useAppDispatch();

  const forgetPassFormik = useFormik({
    initialValues: {
      NationalCode: "",
    },
    validationSchema: yup.object().shape({
      NationalCode: yup.string().required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      postNationalCode(values);
    },
  });

  const {
    data: response,
    trigger: postNationalCode,
    isMutating: postNationalCodeIsMuting,
  } = useSWRMutation(
    [`/Account/ResetPasswordDriver`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setSuccessModal(true);
        forgetPassFormik.resetForm();
      },
    }
  );

  return (
    <>
      <HandleSuccessForgetPassModal
        open={successModal}
        setOpen={setSuccessModal}
        mobileNumber={response?.p}
      />
      <MobileHeader hasScroll={false}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            noWrap
            sx={{
              color: "secondary.main",
              fontWeight: 700,
              fontSize: "14px",
            }}
          >
            ورود به حساب
          </Typography>
          <ArrowTickLeft color={theme.palette.textColor.main} size={14} />
          <Typography
            noWrap
            sx={{
              color: "secondary.main",
              fontSize: "12px",
              fontWeight: 700,
            }}
          >
            بازیابی رمز عبور
          </Typography>
        </Box>
      </MobileHeader>

      <Box
        sx={{
          flex: "1",
          overflowY: "auto",
          width: "100%",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            marginX: "auto",
            width: {
              // xl: "40%",
              // lg: "40%",
              // md: "50%",
              xs: "100%",
            },
          }}
        >
          <Box
            sx={{
              backgroundColor: "bgColor.white",
              justifySelf: "center",
              boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
              paddingX: "10px",
              paddingY: "16px",
              borderRadius: "16px",
              marginX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                justifyContent: "center",
              }}
            >
              <KeyShieldSVG color={theme.palette.secondary[600]} />
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                  color: theme.palette.secondary[600],
                }}
              >
                بازیابی رمز عبور
              </Typography>
            </Box>
            <Box
              sx={{
                backgroundColor: theme.palette.secondary[50],
                padding: "8px",
                mt: 2,
                borderRadius: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <InfoTriangle color={theme.palette.secondary[600]} />
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: theme.palette.secondary[600],
                  }}
                >
                  توجه:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                  textAlign: "justify",
                  color: theme.palette.secondary[600],
                }}
              >
                رمز عبور جدید به شماره تلفن همراه متصل به کد‌ملی شما ارسال
                می‌شود و می‌توانید در صورت نیاز پس از ورود رمز را تغییر دهید.
              </Typography>
            </Box>

            <Box
              sx={{
                mt: "8px",
                paddingX: "8px",
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 700,
                  marginBottom: "8px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                کدملی:
              </InputLabel>
              <CustomInput
                errorMessage={
                  forgetPassFormik.touched.NationalCode &&
                  forgetPassFormik.errors.NationalCode
                }
                error={
                  forgetPassFormik.touched.NationalCode &&
                  Boolean(forgetPassFormik.errors.NationalCode)
                }
                name="NationalCode"
                handelChange={forgetPassFormik.handleChange}
                value={forgetPassFormik.values.NationalCode}
              />
              {/* <MathCaptcha
                lightColor={theme.palette.primary[50]}
                mainColor={theme.palette.primary.main}
              /> */}
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <CustomButton
                loading={postNationalCodeIsMuting}
                onClick={forgetPassFormik.handleSubmit}
                flex={1}
                flexDirection="row"
                title="دریافت رمز عبور جدید"
                justifyContent="center"
                bgColor="primary.main"
                fSize="16px"
                fWeight="700"
                px="10px"
                py="10px"
                borderRadius="10px"
                textColor="lightStatic.main"
                icon1={<SmsTrackingIcon size={22} />}
                mt="16px"
              />
              <CustomButton
                onClick={() => navigate("/login")}
                flexDirection="row"
                title="انصراف"
                justifyContent="center"
                bgColor={theme.palette.error.light}
                fSize="16px"
                fWeight="700"
                borderColor={theme.palette.error.main}
                px="20px"
                py="10px"
                borderRadius="10px"
                textColor="error.main"
                icon1={
                  <CloseCircleSVG color={theme.palette.error.main} size={22} />
                }
                mt="16px"
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <AuthFooter />
    </>
  );
}
